import { backgroundColors } from "../../utils/charts";

export interface ChartDataSet {
  labels: string[];
  datasets: {
    label: string;
    data: number[];
    backgroundColor: string[];
  }[];
}

export function getChartConfig(
  dataInput: DemographicDeviceModels[],
): ChartDataSet | undefined {
  if (!dataInput) {
    return;
  }
  const labels = dataInput.map((item) => {
    return (
      item.range ||
      item.ethnicity ||
      item.gender ||
      item.race ||
      "definitely wrong"
    );
  });

  const data = dataInput.map((item) => {
    return item.count;
  });
  const datasets = [
    {
      label: "",
      data: data,
      backgroundColor: backgroundColors,
    },
  ];
  return { labels, datasets };
}
